// extracted by mini-css-extract-plugin
module.exports = {"ImageBadge":"ImageBadge_ImageBadge__SfAor"};